import { render, staticRenderFns } from "./empty-bills.vue?vue&type=template&id=16594ec4&scoped=true&"
import script from "./empty-bills.vue?vue&type=script&lang=js&"
export * from "./empty-bills.vue?vue&type=script&lang=js&"
import style0 from "./empty-bills.vue?vue&type=style&index=0&id=16594ec4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16594ec4",
  null
  
)

export default component.exports